import { DatePicker } from '@mui/x-date-pickers'
import { useState } from 'react'
import { TextField, useTheme } from '@mui/material'
import moment from 'moment'

const MUIDatePicker = ({
    handleChange,
    value,
    minDate = '',
    maxDate = '',
    disabled = false,
    dateFormat = 'D MMMM YYYY',
    showWarningColor = false,
    label = '',
    fieldProps = {},
    customComponents = {},
    customComponentsProps = {},
}) => {
    const [open, setOpen] = useState(false)
    const theme = useTheme()

    return (
        <DatePicker
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            value={moment(value)}
            onChange={(e) => {
                handleChange(e)
            }}
            minDate={moment(minDate)}
            maxDate={moment(maxDate)}
            disabled={disabled}
            slots={{
                field: TextField,
                ...customComponents,
            }}
            slotProps={{
                field: {
                    onClick: () => {
                        if (disabled) return
                        setOpen((open) => !open)
                    }, // Trigger picker on click
                    label: label,
                    clearable: true,
                    type: 'text',
                    value: value
                        ? moment.utc(value).local().format(dateFormat)
                        : '',
                    InputLabelProps: {
                        shrink: true,
                    },
                    inputProps: {
                        style: {
                            color: showWarningColor
                                ? theme?.palette?.warning?.main
                                : 'black',
                        },
                        readOnly: 'true',
                    },
                    ...fieldProps,
                },
                openPickerButton: {
                    onClick: (e) => {
                        e.preventDefault()
                    },
                    sx: { display: 'none' },
                },
                actionBar: {
                    actions: ['clear', 'today'],
                },
                ...customComponentsProps,
            }}
        />
    )
}

export default MUIDatePicker
